<div class="px-2">
  <div class="">
    <div class="rr-elevation-z2 table-responsive">
      <table class="table table-hover rr-table">
        <thead class="rr-table-header">
          <tr>
            <!--<th class="hide-desktop" style="width: 75px;"></th>-->
            <th class="text-nowrap text-center" style="width: 15%; min-width: 75px;">Favorite</th>
            <th class="text-nowrap" style="width: 50%;">
              Report
              <span class="pl-1 pointer-cursor" title="Sort" *ngIf="availableReportsSort.reportName"><i class="fas fa-sort-amount-up-alt" (click)="sortReportsBy('reportName')"></i></span>
              <span *ngIf="!availableReportsSort.reportName" class="pl-1 pointer-cursor" title="Sort"><i class="fas fa-sort-amount-down" (click)="sortReportsBy('reportName')"></i></span>
            </th>
            <th class="text-nowrap" style="width: 25%;">
              Group
              <span class="pl-1 pointer-cursor" title="Sort" *ngIf="availableReportsSort.reportGroup && !groupID"><i class="fas fa-sort-amount-up-alt" (click)="sortReportsBy('reportGroup')"></i></span>
              <span *ngIf="!availableReportsSort.reportGroup && !groupID" class="pl-1 pointer-cursor" title="Sort"><i class="fas fa-sort-amount-down" (click)="sortReportsBy('reportGroup')"></i></span>
            </th>
          </tr>
        </thead>
        <tbody>
          <!--ALL VIEW-->
          <ng-container *ngIf="groupView == 'all'">
            <!--LIST OF A SELECTED GROUP-->
            <ng-container *ngIf="groupID">
              <tr *ngFor="let report of (availableReports | reportGroupFilter: groupID).reports | reportQueryFilter: filters.reportQuery | reportSortBy: sortColumn : sortDesc | paginate: { itemsPerPage: paginatePerPage, currentPage: p1, id: 'reportsPaginate' }; index as i">
                <ng-container *ngIf="report.reportGroupID === groupID">
                  <td class="pointer-cursor text-center">
                    <span *ngIf="!report.isFavorite" (click)="addToFavorites(report.reportID, report.reportGroupID)" title="Toggle favorite report" class="light-icon p-2"><i class="far fa-star"></i></span>
                    <span *ngIf="report.isFavorite" (click)="confirmRemove(report.reportID, report.reportGroupID)" title="Toggle favorite report" class="favorited-icon p-2"><i class="fas fa-star"></i></span>
                  </td>
                  <td>
                    <a href="{{reportServer}}Default?reportid={{report.reportID}}" target="_blank">
                      <span style="font-size: 1.15em;"><strong>{{report.reportName}}</strong></span>
                      <p class="mb-0 no-under-hover"><em class="text-muted no-under-hover">{{report.reportDescription}}</em></p>
                    </a>
                  </td>
                  <td>
                    <span class="badge badge-dark" style="font-size: 100%;">{{report.reportGroup}}</span>
                  </td>
                </ng-container>
              </tr>
              <tr *ngIf="((availableReports | reportGroupFilter: groupID).reports | reportQueryFilter: filters.reportQuery).length == 0 && !listDisplay" class="text-center ignore-hover">
                <td colspan="3"><em>No reports matching filters found</em></td>
              </tr>
            </ng-container>
            <!--LIST OF ALL GROUPS-->
            <ng-container *ngIf="!groupID">
              <tr *ngFor="let report of totalReports.reports | reportQueryFilter: filters.reportQuery | reportSortBy: sortColumn : sortDesc | paginate: { itemsPerPage: paginatePerPage, currentPage: p1, id: 'reportsPaginate' }; index as i">
                <ng-container *ngIf="!groupID || report.reportGroupID === groupID">
                  <td class="pointer-cursor text-center">
                    <span *ngIf="!report.isFavorite" (click)="addToFavorites(report.reportID, report.reportGroupID)" title="Toggle favorite report" class="light-icon p-2"><i class="far fa-star"></i></span>
                    <span *ngIf="report.isFavorite" (click)="confirmRemove(report.reportID, report.reportGroupID)" title="Toggle favorite report" class="favorited-icon p-2"><i class="fas fa-star"></i></span>
                  </td>
                  <td>
                    <a href="{{reportServer}}Default?reportid={{report.reportID}}" target="_blank">
                      <span style="font-size: 1.15em;"><strong>{{report.reportName}}</strong></span>
                      <p class="mb-0 no-under-hover"><em class="text-muted no-under-hover">{{report.reportDescription}}</em></p>
                    </a>
                  </td>
                  <td>
                    <span class="badge badge-dark" style="font-size: 100%;">{{report.reportGroup}}</span>
                  </td>
                </ng-container>
              </tr>
              <tr *ngIf="(totalReports.reports | reportQueryFilter: filters.reportQuery).length == 0" class="text-center ignore-hover">
                <td colspan="3"><em>No reports matching filters found</em></td>
              </tr>
            </ng-container>
          </ng-container>

          <!--FAVORITES VIEW-->
          <ng-container *ngIf="groupView == 'favorites'">
            <ng-container *ngIf="groupID">
              <tr *ngFor="let report of (favoriteGroups | reportGroupFilter: groupID).reports | reportQueryFilter: filters.reportQuery | reportSortBy: sortColumn : sortDesc | paginate: { itemsPerPage: paginatePerPage, currentPage: p1, id: 'reportsPaginate' }; index as i">
                <td class="pointer-cursor text-center">
                  <span (click)="confirmRemove(report.reportID, report.reportGroupID)" title="Toggle favorite report" class="favorited-icon p-2"><i class="fas fa-star"></i></span>
                </td>
                <td>
                  <a href="{{reportServer}}Default?reportid={{report.reportID}}" target="_blank">
                    <span style="font-size: 1.15em;"><strong>{{report.reportName}}</strong></span>
                    <p class="mb-0 no-under-hover"><em class="text-muted no-under-hover">{{report.reportDescription}}</em></p>
                  </a>
                </td>
                <td>
                  <span class="badge badge-dark" style="font-size: 100%;">{{report.reportGroup}}</span>
                </td>
              </tr>
              <tr *ngIf="((favoriteGroups | reportGroupFilter: groupID).reports | reportQueryFilter: filters.reportQuery).length == 0 && !listDisplay" class="text-center ignore-hover">
                <td colspan="3"><em>No reports matching filters found</em></td>
              </tr>
            </ng-container>
            <ng-container *ngIf="!groupID">
              <tr *ngFor="let report of favoriteReports.reports | reportQueryFilter: filters.reportQuery: favoriteReports.reports.length | reportSortBy: sortColumn : sortDesc | paginate: { itemsPerPage: paginatePerPage, currentPage: p1, id: 'reportsPaginate' }; index as i">
                <ng-container *ngIf="!groupID || report.reportGroupID === groupID">
                  <td class="pointer-cursor text-center">
                    <span (click)="confirmRemove(report.reportID, report.reportGroupID)" title="Toggle favorite report" class="favorited-icon p-2"><i class="fas fa-star"></i></span>
                  </td>
                  <td>
                    <a href="{{reportServer}}Default?reportid={{report.reportID}}" target="_blank">
                      <span style="font-size: 1.15em;"><strong>{{report.reportName}}</strong></span>
                      <p class="mb-0 no-under-hover"><em class="text-muted no-under-hover">{{report.reportDescription}}</em></p>
                    </a>
                  </td>
                  <td>
                    <span class="badge badge-dark" style="font-size: 100%;">{{report.reportGroup}}</span>
                  </td>
                </ng-container>
              <tr *ngIf="favoriteReports.reports.length == 0" class="text-center ignore-hover">
                <td colspan="3"><em>No favorite reports found. To favorite a report click the <span class="px-1"><i class="far fa-star"></i></span> next to the report name.</em></td>
              </tr>
              <tr *ngIf="((favoriteReports.reports | reportQueryFilter: filters.reportQuery).length == 0) && (favoriteReports.reports.length > 0)" class="text-center ignore-hover">
                <td colspan="3"><em>No reports matching filters found</em></td>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </table>
      <div class="rr-table-footer d-flex flex-wrap flex-column flex-sm-row justify-content-between align-items-center bg-white p-2">
        <div *ngIf="!groupID" style="font-size: 0.8em">
          <span class="text-muted" *ngIf="groupView == 'all'">Total: {{ (totalReports.reports | reportQueryFilter: filters.reportQuery).length }}</span>
          <span class="text-muted" *ngIf="groupView == 'favorites'">Total: {{ (favoriteReports.reports | reportQueryFilter: filters.reportQuery).length }}</span>
        </div>
        <div *ngIf="groupID" style="font-size: 0.8em">
          <span class="text-muted" *ngIf="groupView == 'all'">Total: {{ ((availableReports | reportGroupFilter: groupID).reports | reportQueryFilter: filters.reportQuery).length }}</span>
          <span class="text-muted" *ngIf="groupView == 'favorites'">Total: {{ ((favoriteGroups | reportGroupFilter: groupID).reports | reportQueryFilter: filters.reportQuery).length }}</span>
        </div>
        <div class="text-center py-2 py-md-0" style="font-size: 0.9em">
          <pagination-controls (pageChange)="p1 = $event" id="reportsPaginate"></pagination-controls>
        </div>
        <div class="">
          <div class="input-group input-group-sm" style="font-size: 0.9em">
            <div class="input-group-prepend">
              <label class="input-group-text" style="font-size: 0.9em" for="paginatePerPage">Per Page: </label>
            </div>
            <select class="form-control" [(ngModel)]="paginatePerPage" style="font-size: 0.9em">
              <option value="12">12</option>
              <option value="24">24</option>
              <option value="10000">All</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
